export default class BaseAppError extends Error {
  public showToast = false;

  public showMessageInToast = false;

  public useGlobalHandler = true;

  constructor(
    message = '',
    showToast = true,
    showMessageInToast = false,
    useGlobalHandler = true,
  ) {
    super(message);
    this.message = message || this.name;
    this.showToast = showToast;
    this.showMessageInToast = import.meta.env.DEV || showMessageInToast;
    this.useGlobalHandler = useGlobalHandler;
  }
}
